const inboundConfigurationConstants = require('./inbound-configuration');
const indentFreightChargeConstants = require('./indent-freight-charge');
const transporterBasedVehiclesConstants = require('./transporter-based-vehicles');
const openIndentRFQConstants = require('./open-indent-rfq');
const noFreightIndentConstants = require('./no-freight-indent');
const indentBulkUploadConstants = require('./indent-bulk-upload');
const marketPlaceConstants = require('./market-place');
const trackTraceConstants = require('./track-trace');
const materialHeaderConstants = require('./material-header');
const acrossIndentMaterialUploadHeaderConstants = require('./across-indent-material-header');
const loadWeightVolumeFromMasterConstants = require('./load-weight-volume');
const avoidManualMaterialInvoiceConstants = require('./manual-material-invoice');
const materialHeaderPathConstants = require('./material-header-path-constants');
const materialUpdateCombinationConstants = require('./material-update-combination');
const materialInvoiceBeforeTruckOutConstants = require('./material-invoice-before-truckout');
const avoidBackDateConstants = require('./avoid-back-date');
const truckInspectionConstants = require('./truck-inspection-constants');
const reportedAtDepotConstants = require('./reported-at-depot');
const trackFirstLoadPointConstants = require('./track-first-load-point');
const lrForTruckOut = require('./lr-for-truck-out');
const freightSettings = require('./freight_settings');

const slaSettingsConstants = require('./sla-settings');
const transporterChangeTruckTypeConstants = require('./transporter-change-truck-type');
const rfqConstants = require('./rfq');
const autoSwitchTransporterConstants = require('./auto-switch-transporter');
const indentCancelationConstants = require('./indent-cancelation');
const MarkIndentDeliveredConstants = require('./mark-indent-delivered');
const grnLRUploadConstants = require('./grn-lr-upload');
const shipperRequiredToFillGRNConstants = require('./shipper-required-to-fill-grn');


module.exports = {
  displayName: 'INDENT MANAGEMENT',
  description: 'Manage shipment to delivery',
  sortOrder: 3,
  name: 'indentManagement',
  documentKey: 'indent_management',
  displayColorClass: 'borderfill-yellow-light',
  sections: {
    create: {
      displayName: 'Create',
      description: 'What types of indents can this client create?',
      sortOrder: 1,
      name: 'create',
      configurations: {
        inboundConfigurationSettings: inboundConfigurationConstants,
        indentFreightCharge: indentFreightChargeConstants,
        tranasporterBasedVehicles: transporterBasedVehiclesConstants,
        openIndentRFQ: openIndentRFQConstants,
        noFreightIndent: noFreightIndentConstants,
        indentBulkUpload: indentBulkUploadConstants,
        marketPlace: marketPlaceConstants,
        trackTrace: trackTraceConstants,
      },
    },
    materials: {
      displayName: 'Materials',
      description: 'Where + How to fetch materials',
      sortOrder: 2,
      name: 'materials',
      configurations: {
        materialHeader: materialHeaderConstants,
        acrossIndentMaterialUploadHeader: acrossIndentMaterialUploadHeaderConstants,
        loadWtVolFromMaster: loadWeightVolumeFromMasterConstants,
        avoidManualMaterialInvoiceUpdate: avoidManualMaterialInvoiceConstants,
        materialHeaderPath: materialHeaderPathConstants,
        material_update_combination: materialUpdateCombinationConstants,
        material_invoice_before_truckout: materialInvoiceBeforeTruckOutConstants,
      },
    },
    indentRules: {
      displayName: 'Indent Rules',
      description: 'Applies to all indents and its actions',
      sortOrder: 3,
      name: 'indentRules',
      configurations: {
        avoid_back_date: avoidBackDateConstants,
        truck_inspection: truckInspectionConstants,
        reported_at_depot: reportedAtDepotConstants,
        track_first_load_point: trackFirstLoadPointConstants,
        lr_for_truck_out: lrForTruckOut,
        freight_settings: freightSettings,
        // truck_utilization: {},
        // utilization_threshold: {},
        // indent_create: {},
        // sim_tracking: {},
      },
    },
    exceptions: {
      displayName: 'Exceptions',
      description: 'Plan, for when things go sideways',
      sortOrder: 4,
      name: 'exceptions',
      configurations: {
        sla: slaSettingsConstants,
        transporter_change_truck_type: transporterChangeTruckTypeConstants,
        rfq: rfqConstants,
        auto_switch_transporter_on_non_placement: autoSwitchTransporterConstants,
        indentCancelation: indentCancelationConstants,
      },
    },
    indentClosure: {
      displayName: 'Indent Closure',
      description: 'Everything needed to mark as delivered',
      sortOrder: 5,
      name: 'indentClosure',
      configurations: {
        markIndentAsDelivered: MarkIndentDeliveredConstants,
        grnLRUpload: grnLRUploadConstants,
        is_shipper_required_to_fill_grn: shipperRequiredToFillGRNConstants,
      },
    },
  },
};
